/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit'; 
import { getAllDevice, getDeviceHistory } from './deviceAction';

const initialState = {
    data: {},
    devices: {},
    deviceHistory: {}
}
const deviceSlice = createSlice({
    name: 'device',
    initialState,
    extraReducers: {

        [getAllDevice.fulfilled]: (state, { payload }) => {
            state.devices =  payload;
        },
        [getDeviceHistory.fulfilled]: (state, { payload }) => {
            state.deviceHistory =  payload;
        },
        [getDeviceHistory.rejected]: (state, { payload }) => {
            state.deviceHistory =  {};
        },
    }
});

export default deviceSlice.reducer